<template>
  <header>
    <h1><a href="javascript:;" @click="goPage('title')"><img alt="kt cloud martketplace 로고"
                                                             src="@/assets/img/common/gnb_logo.png"></a></h1>
    <div
        :class="!state.isSiteDropdown ? 'dropdown' : 'dropdown on'"
        data-hd-dropdown
        @click="state.isSiteDropdown = !state.isSiteDropdown">
      <button data-dropdown-btn type="button">
        <template v-if="state.type != 'enterprise'">공공</template>
        <template v-if="state.type == 'enterprise'">기업</template>
        <span class="sr_only">펼치기</span></button>
      <ul>
        <li><a href="https://market.cloud.kt.com" target='_blank'>기업</a></li>
        <li><a href="https://market.gcloud.kt.com" target='_blank'>공공</a></li>
      </ul>
    </div>
    <nav>
      <ul>
        <!-- li.on - 활성화 -->
        <li class="on"><a href="javascript:;" @click="goPage('title')">
          <template v-if="state.type == 'public'">공공 마켓플레이스</template>
          <template v-else>기업 마켓플레이스</template>
          제휴사 포털</a></li>
      </ul>
    </nav>
    <div class="tnb">
      <div v-if="state.isLogin"
           :class="!state.isLoginDropdown ? 'dropdown' : 'dropdown on'"
           data-hd-dropdown
           @click="state.isLoginDropdown = !state.isLoginDropdown"><!-- 클래스 on으로 리스트 토글 -->
        <button data-dropdown-btn type="button">
          <template v-if="state.loginName != '' ">
            {{ state.loginName }}님
          </template>
          <template v-else>로그인</template>
          <span class="sr_only">펼치기</span></button>
        <ul v-if="state.isLogin">
          <li><a href="javascript:;" @click="goPage('managerInfo')">가입정보</a></li>
          <li><a href="javascript:;" @click="goPage('login')">로그아웃</a></li>
        </ul>
      </div>

      <div v-else class="dropdown"><!-- 클래스 on으로 리스트 토글 -->
        <button style="background-image: none !important; padding: 15px 33px 15px 33px !important;" type="button"
                @click="goPage('signUp')">
          회원가입
        </button>
      </div>
      <div v-if="state.isLogin" :class="state.notiClick ? 'notice_wrap on' : 'notice_wrap'">
        <button :class="{'new' : state.notiList.length != 0}" data-nt-btn type="button"
                @click="state.notiClick = !state.notiClick"><img alt="" src="@/assets/img/icon/ic_noti.svg"></button>
        <div class="notice">
          <div>
            <p class="tit">알림</p>
            <button class="btn only_icon" data-nt-del type="button" @click="state.notiClick = !state.notiClick"><img
                alt="" src="@/assets/img/common/ic_delete.svg"></button>
            <ul>
              <li v-for="item in state.notiList" :key="item">
                <a :title="item.notification_details" href="javascript:;" @click="notiClick(item)">
                  {{ item.notification_details }}
                </a>
                <span>{{ moment(item.inst_date).format('YY-MM-DD / HH:mm') }}</span>
              </li>
              <li v-if="state.notiList.length == 0">
                <a href="javascript:;">
                  알림이 없습니다.
                </a>
                <span></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <a class="btn purple" href="javascript:;" @click="goPage('entry')">제휴/등록 안내</a>
    </div>
  </header>
</template>

<script>
import {computed, inject, onBeforeMount, reactive} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import commonMgt from "@/assets/js/marketPartnerCommon.js";
import moment from "moment";

export default {
  name      : 'Header',
  components: {moment},
  setup     : () => {
    const store = useStore();
    const router = useRouter();
    const {common} = commonMgt();
    const emitter = inject("emitter");

    const state = reactive({
      userNm         : computed(() => store.getters["staLogin/getUserNm"]),
      memSq          : computed(() => store.getters["staLogin/getMemSq"]),
      isLogin        : false,
      notiList       : [],
      notiOpen       : false,
      isSiteDropdown : false,
      isLoginDropdown: false,
      type           : process.env.VUE_APP_POTAL_MARKET_TYPE,
      loginName      : store.getters["staLogin/getManagerName"],
    });

    const goPage = (str) => {
      if (str == 'login') {
        router.push({name: 'Login'});
      } else if (str == 'managerInfo') {
        router.push({name: 'ManagerInfo'});
      } else if (str == 'entry') {
        router.push({name: 'EntryApplicationGuide'});
      } else if (str == 'title') {
        if (state.isLogin) {
          router.push({name: 'DashBoard'});
        } else {
          router.push({name: 'Login'});
        }
      } else if (str == 'signUp') {
        router.push({name: 'SignUp'});
      }
    }

    emitter.on("myLogin", (value) => {
      state.isLogin = value;
      state.loginName = store.getters["staLogin/getManagerName"]
    });

    emitter.on("getNoti", (value) => {
      if (state.isLogin && value) {
        getNoti();
      }
    });
    const getNoti = () => {
      if (state.memSq != null) {
        var map = {
          'memSq': state.memSq,
        }
        common.https(true).post("partner/user/getNoti", map)
        .then((response) => {
          state.notiList = response.data.data.list;
        }).catch((response) => {
        });
      }

    }

    const notiClick = (item) => {
      item.memSq = state.memSq;
      common.https(true).post("partner/user/clickNoti", item)
      .then((response) => {
        getNoti();
      }).catch((response) => {
      });
    }
    onBeforeMount(() => {
      var authorization = store.getters["staLogin/getPartnerAccessToken"];

      if (!common.isEmpty(authorization)) {
        state.isLogin = true;
        nameMasking();
        getNoti()
      } else {
        state.isLogin = false;
      }
    });

    const nameMasking = () => {
      if (state.loginName != "") {
        let originStr = state.loginName;
        let maskingStr;
        let strLength;
        strLength = originStr.length;
        if (strLength < 3) {
          maskingStr = originStr.replace(/(?<=.{1})./gi, "*");
        } else {
          maskingStr = originStr.replace(/(?<=.{2})./gi, "*");
        }
        state.loginName = maskingStr;
      }
    }

    return {
      state,
      goPage,
      moment,
      notiClick
    }
  }
}
</script>
